<section>
  <div class="d-flex justify-content-center">
    <div class="alert alert-light font-size-sm" role="alert">
      <i class="fas fa-info-circle fa-md" aria-hidden="true"></i> Click Previous or a Progress icon to edit the event before submission.
    </div>
  </div>
  <h2>Event Summary</h2>
  <ng-container *ngFor="let notification of eventNotification$ | async">
    <div class="row g-2 mb-2">
      <div class="col notice-default" [ngClass]="'notice-' + notification.NotificationType.toLowerCase()">
        <button type="button" class="btn btn-link p-0 fw-bold" title="{{'Edit ' + notification.header}}" (click)="navigateToStep(notification.RouteLink)"><i class="far fa-check-circle fa-md me-1" aria-hidden="true"></i> {{ notification.header }}</button>
        <ng-container *ngIf="notification.message">
          <div class="my-2"><i class="me-2 fas fa-exclamation-circle" aria-hidden="true"></i> <span [innerHTML]="notification.message"></span></div>
        </ng-container>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-link p-0" title="{{'Edit ' + notification.header}}" (click)="navigateToStep(notification.RouteLink)"><i class="fas fa-pencil-alt" aria-hidden="true"></i><span class="visually-hidden">Edit {{ notification.header }}</span></button>
      </div>
    </div>
  </ng-container>
</section>
